export default __webpack_public_path__ + "static/media/2.83c111b0.jpg";